import WebApi from "@/views/loyalty/shared/modules/web_api"

export class UserprofileEndpoint {
    constructor (store) {
        this.url = `${process.env.VUE_APP_LOYALTY_URL}api/user_profile/`
        this.webApi = new WebApi(store)
            .editSuccess("Профиль пользователя сохранен успешно!")
            .editError("Ошибка при сохранении профиля пользователя")
            .readError("Ошибка при загрузке профиля пользователя")
    }

    async create_user_profile (customerId, customerNumber, userProfile) {
        const response = await this.webApi.post(`${this.url}${customerId}/${customerNumber}`, userProfile)
        if (!response.status_code) {
            return response
        } else {
            console.error(`Ошибка с кодом: ${response.status_code}`)
        }
    }

    async get_customer_numbers (userProfileId) {
        const customerNumbers = await this.webApi.get(`${this.url}customer/${userProfileId}`)
        if (!customerNumbers.status_code) {
            return customerNumbers
        } else {
            console.error(`Ошибка с кодом: ${customerNumbers.status_code}`)
        }
    }

    async get_user_profile_by_login (login) {
        const response = await this.webApi.get(`${this.url}login/${login}`)
        if (!response.status_code) {
            return response
        } else {
            console.error(`Ошибка с кодом: ${response.status_code}`)
        }
    }

    async get_user_profile_list_by_customer_id (customerId, page, limit, filter, search) {
        const users = await this.webApi.post(`${this.url}list/customer/${customerId}`, {
            page: page,
            limit: limit,
            filter: filter,
            search: search
        })
        console.log('get_user_profile_list_by_customer_id users', users)
        if (!users.status_code) {
            return users
        } else {
            console.error(`Ошибка с кодом: ${users.status_code}`)
        }
    }

    async get_user_profile_participant_all () {
        const users = await this.webApi.get(`${this.url}participant/all/`)
        if (!users.status_code) {
            return users
        } else {
            console.error(`Ошибка с кодом: ${users.status_code}`)
        }
    }

    async update_user_profile (userProfile) {
        const response = await this.webApi.patch(`${this.url}`, userProfile)
        if (!response.status_code) {
            return response
        } else {
            console.error(`Ошибка с кодом: ${response.status_code}`)
        }
    }

    async update_user_profile_create_password (userProfileId, createPassword) {
        await this.webApi.put(`${this.url}create_password/${userProfileId}`, createPassword)
    }

    async upload_file (customerId, customerNumber, file_to_upload) {
        const formData = new FormData()
        formData.append("file", file_to_upload)
        await this.webApi.post(`${this.url}upload/${customerId}/${customerNumber}`, formData, {
        headers: {
                        "Content-Type": "application/form-data",
                    },
        })
            }
        }
